const getDiscountConfig = (productData, isSubscribe) => {
  if (isSubscribe) {
    return {
      enabled: !!productData?.subscription?.subscription_discount_enable,
      settings: productData?.subscription?.subscription_discount_codes,
    };
  }

  return {
    enabled: !!productData?.enable_discount_codes,
    settings: productData?.discount_codes,
  };
};

const getDiscountSettings = (productData, isSubscribe) => getDiscountConfig(productData, isSubscribe).settings;

const isDiscountEnabledForSelection = (productData, isSubscribe) => {
  const config = getDiscountConfig(productData, isSubscribe);
  return !!(config.enabled && config.settings);
};

const isDiscountCodeMatch = (settings, discountCode) => {
  if (!settings || discountCode === undefined || discountCode === null) return false;

  const expected = String(settings.discount_code || "")
    .trim()
    .toUpperCase();
  const actual = String(discountCode).trim().toUpperCase();

  return expected.length > 0 && actual === expected;
};

const isDiscountActive = (productData, isSubscribe, discountCode, isDiscountApplied = true) => {
  const { enabled, settings } = getDiscountConfig(productData, isSubscribe);

  if (!enabled) return false;
  if (!isDiscountCodeMatch(settings, discountCode)) return false;

  return isDiscountApplied !== false;
};

// ACF returns the expiration date as d/m/Y; the code stays valid until the end of that day.
const isDiscountExpired = (settings, now = new Date()) => {
  if (!settings?.code_has_expiration_date || !settings?.discount_code_expiration_date) return false;

  const [day, month, year] = settings.discount_code_expiration_date.split("/");
  const expirationDate = new Date(year, month - 1, day);
  expirationDate.setHours(23, 59, 59, 999);

  return now > expirationDate;
};

// The mode lives on the product pack, so it covers the subscription codes too.
const isDiscountPopupMode = (productData) =>
  !!productData?.enable_discount_codes && productData?.discount_codes_mode === "popup";

const DISCOUNT_PERCENT_VARIABLE = "###discountPercent###";

// The extra discount a package's promo price gives on its displayed price,
// e.g. 10 for 23.45 -> 21.11. Null when the package has no lower promo price.
const getPromoDiscountPercent = (product) => {
  const price = Number(product?.price);
  const promoPrice = Number(product?.promo_discounted_price);

  if (!(price > 0) || !(promoPrice > 0) || promoPrice >= price) return null;

  return Math.round(((price - promoPrice) / price) * 100);
};

const replaceDiscountPercentVariable = (text, product) => {
  if (typeof text !== "string" || !text.includes(DISCOUNT_PERCENT_VARIABLE)) return text;

  return text.split(DISCOUNT_PERCENT_VARIABLE).join(getPromoDiscountPercent(product) ?? "");
};

export {
  getDiscountConfig,
  getDiscountSettings,
  isDiscountEnabledForSelection,
  isDiscountCodeMatch,
  isDiscountActive,
  isDiscountExpired,
  isDiscountPopupMode,
  getPromoDiscountPercent,
  replaceDiscountPercentVariable,
};
